import React from 'react';



const YouTubeEmbed = ({ channelId }) => {
  return (
    <div className="youtube-embed-container">
      <iframe
        width="100%"
        height="500"
        src={`https://www.youtube.com/embed/live_stream?channel=${channelId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube Live Stream"
      />
    </div>
  );
};

export default YouTubeEmbed;